import { SyncState } from '../../types.ts';

export const getBumpedSyncState = (syncState?: SyncState): SyncState => ({
  editRevision: (syncState?.editRevision ?? 0) + 1,
  serverRevision: syncState?.serverRevision ?? 0,
  status: syncState?.status ?? 'success',
});
